import type { JSX } from 'solid-js';
import { UNSET } from '../lib/unset';
import { StatusPill, type StatusTone } from './StatusPill';

// One escalation tier (#195, mock "Escalation matrix"): a tone-coded Status
// chip over the tier's category list.
export function EscalationRow(props: {
  tone: StatusTone;
  label: string;
  cats: string[];
}): JSX.Element {
  return (
    <li class="repo-policy__tier">
      <StatusPill tone={props.tone}>{props.label}</StatusPill>
      <p class="repo-policy__cats">{props.cats.length > 0 ? props.cats.join(' · ') : UNSET}</p>
    </li>
  );
}
